import CrHead from './cr-head';
import CrNav from './cr-nav';
import GoogleAnalyticsBase from './analytics/google-analytics-base';
import FacebookAnalyticsBase from './analytics/facebook-analytics-base';
import Footer from './footer';

const Layout = ({ includeCrHead = true, pageTitle, linkHighlight, pageDescription, children }) => {
  return (
    <>
      {includeCrHead && <CrHead pageTitle={pageTitle} pageDescription={pageDescription} />}
      <GoogleAnalyticsBase />
      <FacebookAnalyticsBase />
      <CrNav linkHighlight={linkHighlight} />
      {children}
      <Footer />
    </>
  );
};

module.exports = Layout;
